class CustomCollection extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
  }

  connectedCallback() {
    this.init();
    this.bindEvents();
  }

  init() {
    this.productsGrid = this.querySelector('.s-custom-collection__products-grid');
    this.loadMoreButton = this.querySelector('.s-custom-collection__load-more-btn');
    
    // Get collection data
    const collectionData = this.querySelector('#collection-data');
    if (collectionData) {
      this.collectionHandle = collectionData.dataset.handle;
      this.totalProducts = parseInt(collectionData.dataset.totalProducts) || 0;
    }

    console.log(`Custom Collection initialized: ${this.loadedProducts} products loaded of ${this.totalProducts} total`);
  }

  get loadedProducts() {
    return this.productsGrid.querySelectorAll('.new-product-card').length;
  }

  async loadMoreProducts() {
    if (this.isLoading) return;
    
    this.isLoading = true;
    this.showLoading();
    
    const nextPage = parseInt(this.loadMoreButton.dataset.nextPage) || 2;
    
    try {
      const response = await fetch(`/collections/${this.collectionHandle}?page=${nextPage}&view=new-product-card-ajax`);
      
      if (response.ok) {
        const html = await response.text();
        
        // FIX: Use a more controlled approach to append products
        this.appendProductsSmoothly(html);
        
        // Update page counter for next click
        this.loadMoreButton.dataset.nextPage = nextPage + 1;

        console.log(`Load More: Now loaded ${this.loadedProducts} of ${this.totalProducts} products`);
        
        // Check if we should hide the load more button
        if (this.loadedProducts >= this.totalProducts) {
          this.hideLoadMoreButton();
          console.log('All products loaded - hiding Load More button');
        }
        
      } else {
        console.error('Failed to load products:', response.status);
        this.hideLoadMoreButton();
      }
    } catch (error) {
      console.error('Error loading products:', error);
      this.hideLoadMoreButton();
    } finally {
      this.isLoading = false;
      this.hideLoading();
    }
  }

  appendProductsSmoothly(html) {
    // Create a temporary container to parse the HTML
    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = html;
    
    // Get all the new product cards
    const newProductCards = tempContainer.querySelectorAll('.new-product-card');
    
    if (newProductCards.length === 0) {
      console.log('No new products found in response');
      return;
    }
    
    // Add each product card with a slight delay for smooth animation
    newProductCards.forEach((card, index) => {
      // Clone the node to avoid reference issues
      const clonedCard = card.cloneNode(true);
      
      // Add animation styles
      clonedCard.style.opacity = '0';
      clonedCard.style.transform = 'translateY(20px)';
      clonedCard.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
      
      // Append to grid
      this.productsGrid.appendChild(clonedCard);
      
      // Animate in with staggered delay
      setTimeout(() => {
        clonedCard.style.opacity = '1';
        clonedCard.style.transform = 'translateY(0)';
      }, index * 50); // 50ms delay between each card
    });
    
    console.log(`Added ${newProductCards.length} new products to the grid`);
  }

  bindEvents() {
    // Load more products
    if (this.loadMoreButton) {
      this.loadMoreButton.addEventListener('click', () => this.loadMoreProducts());
    }

    // Sort dropdown functionality
    const sortBtn = this.querySelector('.s-custom-collection__sort-btn');
    const sortDropdown = this.querySelector('#sortDropdown');
    
    if (sortBtn && sortDropdown) {
      sortBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        sortDropdown.classList.toggle('show');
      });
    }

    // Close dropdown when clicking outside
    document.addEventListener('click', () => {
      const sortDropdown = this.querySelector('#sortDropdown');
      if (sortDropdown) {
        sortDropdown.classList.remove('show');
      }
    });
  }

  showLoading() {
    if (this.loadMoreButton) {
      this.loadMoreButton.disabled = true;
      this.loadMoreButton.textContent = 'Loading...';
    }
  }

  hideLoading() {
    if (this.loadMoreButton) {
      this.loadMoreButton.disabled = false;
      this.loadMoreButton.textContent = 'Load More';
    }
  }

  hideLoadMoreButton() {
    if (this.loadMoreButton) {
      this.loadMoreButton.style.display = 'none';
    }
  }
}

// Register the custom element
if (!customElements.get('s-custom-collection')) {
  customElements.define('s-custom-collection', CustomCollection);
}